import type { IntegrationEntry, Subproject } from '../../api/integrations-client/integrations-client.type';
import type { Project } from '../../api/projects-client/projects-client.type';

enum IntegrationStatus {
  Operational = 'Operational',
  Stale = 'Data Stale',
  Expired = 'Token Expired',
}

type IntegrationProject = Omit<IntegrationEntry, 'projects'> & {
  name: string;
  project_id: string;
  subprojects: Subproject[];
  status: IntegrationStatus;
};

type DetailedRepository = {
  id: string;
  name: string;
  projects: Project[];
  external_repository_id: string | number;
  initialized: string;
  full_name: string;
  description: string;
  archived: boolean;
  forks_count: number;
  last_pushed_at: string;
  created_at: string;
  updated_at: string;
  private: boolean;
  open_issues_count: number;
  organization: string;
};

export { IntegrationStatus };
export type { DetailedRepository, IntegrationProject };
